
        
    const runtime = require("../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
            const __nunjucks_template_import__filter_t = require("../../../nunjucks/t.js");
            __nunjucks_module_dependencies__.filters['t'] = {
                module: __nunjucks_template_import__filter_t && __nunjucks_template_import__filter_t.default || __nunjucks_template_import__filter_t,
                async: false
            };
            const __nunjucks_template_import__filter_date = require("../../../nunjucks/date.js");
            __nunjucks_module_dependencies__.filters['date'] = {
                module: __nunjucks_template_import__filter_date && __nunjucks_template_import__filter_date.default || __nunjucks_template_import__filter_date,
                async: false
            };
    
        
            __nunjucks_module_dependencies__.templates["note/views/templates/note-list-item.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<header>\n  ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "perms")),"can_modify")) {
output += "\n  <div class=\"note-admin-menu\">\n    <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n      <i class=\"pwai-settings\"></i>\n    </a>\n    <ul class=\"dropdown-menu\">\n      <li>\n        <a href=\"#\" id=\"edit-note\">";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.list.item.edit"), env.opts.autoescape);
output += "</a>\n      </li>\n      <li>\n        <a href=\"#\" id=\"delete-note\">";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.list.item.delete"), env.opts.autoescape);
output += "</a>\n      </li>\n    </ul>\n  </div>\n  ";
;
}
output += "\n  <h4>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</h4>\n  <div class=\"author-and-time\">\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "is_curriculum_wide_note")) {
output += "\n    <pw-avatar\n      class=\"x-small\"\n      src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"profile")),"image_thumb"), env.opts.autoescape);
output += "\"\n      first-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"first_name"), env.opts.autoescape);
output += "\"\n      last-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"last_name"), env.opts.autoescape);
output += "\"\n      user-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"id"), env.opts.autoescape);
output += "\"\n    >\n    </pw-avatar>\n    ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.list.item.author_written_by",{"first_name": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"first_name")}), env.opts.autoescape);
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "shouldShowFullName")) {
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"last_name"), env.opts.autoescape);
output += " ";
;
}
else {
output += " ";
output += runtime.suppressValue(env.getFilter("first").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "author")),"last_name")), env.opts.autoescape);
output += ". ";
;
}
output += "\n    <time is=\"time-ago\" datetime=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "created_time"), env.opts.autoescape);
output += "\"\n      >";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "created_time"),"MMM D, YYYY h:mm A"), env.opts.autoescape);
output += "</time\n    >\n    ";
;
}
else {
output += "\n    <pw-avatar class=\"x-small\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "school_data")),"media")),"thumb"), env.opts.autoescape);
output += "\"></pw-avatar>\n    ";
output += runtime.suppressValue(env.getFilter("t").call(context, "","notes.list.item.school_written_by",{"school_name": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "school_data")),"school")),"name")}), env.opts.autoescape);
output += " ";
;
}
output += "\n  </div>\n</header>\n<article class=\"note-body brand-content\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "body")), env.opts.autoescape);
output += "</article>\n<div class=\"note-read-more\">\n  <i class=\"pwai-chevrondown\"></i>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "note/views/templates/note-list-item.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "note/views/templates/note-list-item.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["note/views/templates/note-list-item.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    